import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
    Aldeia,
    AtividadePrimaria,
    AtividadeSecundaria,
    CboProfissional, CNES, CNES_TIPO, ConselhoClasse,
    Convenio, DistritoSanitario, Dsei,
    FormaAcesso,
    GrupoAtividadePrimaria,
    GrupoAtividadeSecundaria, GrupoMarcacao,
    Instalacao,
    LeitoDetalhamento, MotivoDesativacao,
    NivelAtencao,
    OrgaoEmissorProfissional,
    PoloBase, Profissional, RegiaoAdministrativa, RegiaoSaude, SubGrupoMarcacao, SubtipoTipoInstalacao, TipoAtividade, TipoComplexidade,
    TipoEntidadeAdministrativa,
    TipoEquipamento,
    TipoEstabelecimento,
    TipoGestao,
    TipoInstalacao,
    TipoLeito,
    TipoMarcacao,
    TipoServico
} from '../models/dominios';
import { UsuarioProvider } from '../providers/usuario.provider';
import { Unidade } from './../models/dominios';
import { ResponseUtil } from './../utils/response.util';
import { BaseService } from './base.service';
import { EstabelecimentoModel } from '../models/cadastro/estabelecimento.model';


@Injectable({
    providedIn: 'root'
})
export class DominioService {

    cacheLista: any = {};

    constructor(
        private http: HttpClient,
        private baseService: BaseService,
        private usuarioProvider: UsuarioProvider
    ) {
    }

    get(clazz: new () => any, filtro = '', codigo = null, params = null): Promise<any> {
        switch (clazz) {
            case FormaAcesso:
                return this.listarFormaDeAcesso(filtro);
            case Convenio:
                return this.listarConvenio(filtro);
            case ConselhoClasse:
                return this.listarConselho(filtro);
            case Instalacao:
                return this.listarInstalacoes(params);
            case TipoInstalacao:
                return this.listarTipoInstalacao();
            case TipoLeito:
                return this.listarTipoLeito();
            case LeitoDetalhamento:
                return this.listarLeitoDetalhamento(codigo);
            case NivelAtencao:
                return this.listarNivelAtencao(codigo);
            case TipoAtividade:
                return this.listarGestaoTipoAtividade();
            case CboProfissional:
                return this.listarCboProfissional(filtro);
            case OrgaoEmissorProfissional:
                return this.listarOrgaoEmissorProfissional();
            case TipoEntidadeAdministrativa:
                return this.listarTipoEntidade();
            case Dsei:
                return this.listarDsei(codigo);
            case RegiaoSaude:
                return this.listarRegioesSaude(filtro, params);
            case DistritoSanitario:
                return this.listarDistrito(filtro, params);
            case RegiaoAdministrativa:
                return this.listarRegiaoAdministrativa(filtro);
            case CNES:
                return this.listarCNES(filtro, codigo);
            case Profissional:
                return this.listarProfissionais(codigo, filtro);
            case Unidade:
                return this.listarUnidades(codigo, filtro);
            case TipoEstabelecimento:
                return this.listarTipoEstabelecimento();
            case PoloBase:
                return this.listarPoloBase(codigo);
            case Aldeia:
                return this.listarAldeia(params);
            case GrupoAtividadePrimaria:
                return this.listarGrupoAtividadePrimaria(codigo);
            case GrupoAtividadeSecundaria:
                return this.listarGrupoAtividadeSecundaria();
            case AtividadePrimaria:
                return this.listarAtividadePrimaria(codigo);
            case AtividadeSecundaria:
                return this.listarAtividadeSecundaria(params);
            case TipoGestao:
                return this.listarTipoGestao();
            case TipoComplexidade:
                return this.listarTipoComplexidade(codigo);
            case TipoMarcacao:
                return this.listarTipoMarcacao();
            case GrupoMarcacao:
                return this.listarGrupoMarcacao();
            case SubGrupoMarcacao:
                return this.listarSubgrupoMarcacao(codigo);
            case MotivoDesativacao:
                return this.listarMotivosDesativacao();
            // case SubtipoTipoInstalacao:
            //     return this.listarSubTipoInstalacao();
            case TipoServico:
                return this.listarDominioServico();
            case CNES_TIPO:
                return this.listarCnesByTipo(codigo, filtro);
            case EstabelecimentoModel:
                return this.listarEstabelecimentoParaNotificacao(filtro);

        }
        return null;
    }

    getUrlParams(params) {
        const url = Object.keys(params).map((k) => {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
        }).join('&');
        return url;
    }

    async listarTipoEntidade(filtro?): Promise<Array<CboProfissional>> {
        const url = `/tipo-entidade-administrativa`;
        return this.baseService.get(url).toPromise();
    }

    async listarCboProfissional(filtro?): Promise<any> {
        const url = `${environment.urlBaseNova}/corporativo/cbo`;
        return this.http.get(url).toPromise();
    }

    // async listarOrgaoEmissorProfissional(): Promise<Array<OrgaoEmissorProfissional>> {
    async listarOrgaoEmissorProfissional(cbo = null) {
        let url = `${environment.urlBaseNova}/cnes/conselhos-classe`;
        if (cbo) {
            url += `?cbo=${cbo}`;
        }
        // return this.http.get('./assets/dados-fake/recursos-humanos/conselhos.json').toPromise();
        return this.http.get(url).toPromise();
    }

    async getConselhoClasseById(id: string) {
        const url = `/cnes/conselhos-classe/${id}`;
        return this.baseService.get(url).toPromise();
    }

    async listarFormaDeAcesso(filtro = ''): Promise<any> {
        const url = `${environment.urlBaseNova}/cnes/formas-acesso`;
        return this.http.get(url).toPromise();
    }

    async listarConvenio(filtro = ''): Promise<any> {
        const url = `${environment.urlBaseNova}/cnes/convenios`;
        return this.http.get(url).toPromise();
    }

    async listarConselho(filtro): Promise<Array<ConselhoClasse>> {
        const url = `/rh/conselho-classe`;
        return this.baseService.get(url).toPromise();
    }

    async listarInstalacoes(filtro): Promise<any> {
        const url = environment.urlBaseNova + '/cnes/instalacoes?id-subtipo-instalacao=' + filtro.subTipo;
        return this.http.get(url).toPromise();
    }

    async listarTipoInstalacao(): Promise<Array<TipoInstalacao>> {
        const url = environment.urlBaseNova + '/cnes/instalacoes/tipos';
        return this.http.get<Array<TipoInstalacao>>(url).toPromise();
    }

    async listarSubTipoInstalacao(id): Promise<SubtipoTipoInstalacao> {
        const url = environment.urlBaseNova + `/cnes/instalacoes/tipos/${id}/subtipos`;
        return this.http.get<SubtipoTipoInstalacao>(url).toPromise();
    }

    async listarTipoLeito(): Promise<Array<TipoLeito>> {
        const url = environment.urlBaseNova + '/cnes/leitos/tipos';
        return this.http.get<Array<TipoLeito>>(url).toPromise();
    }

    async listarLeitoDetalhamento(codigo): Promise<any> {
        const url = environment.urlBaseNova + '/cnes/leitos?codigoTipoLeito=' + codigo;
        return this.http.get(url).toPromise();
    }

    async listarTipoEquipamento(): Promise<Array<TipoEquipamento>> {
        const url = environment.urlBaseNova + '/cnes/equipamentos/tipos';
        return this.http.get<Array<TipoEquipamento>>(url).toPromise();
    }

    listarEquipamentoPorTipo(codigo) {
        const url = environment.urlBaseNova + '/cnes/equipamentos?codigoTipoEquipamento=' + codigo;
        return this.http.get(url).toPromise();
    }

    async listarDsei(municipioIbge): Promise<any> {
        const url = `${environment.urlBaseNova}/corporativo/dsei?codigo-municipio-ibge=${municipioIbge}`;
        return this.http.get(url).toPromise();
    }

    async listarPoloBase(dsei): Promise<any> {
        const url = `${environment.urlBaseNova}/corporativo/polobase?codigo-dsei=${dsei}`;
        return this.http.get(url).toPromise();
    }

    async listarAldeia(params): Promise<any> {
        const url = `${environment.urlBaseNova}/corporativo/aldeia?codigo-dsei=${params.codigoDsei}&codigo-polo-base=${params.codigoPolo}`;
        return this.http.get(url).toPromise();
    }

    async listarInesPorCNES(cne, pagina = 0, tamanhoPag = 10): Promise<any> {
        const url = `${environment.urlBaseNova}/cnes/ine?tamanho-pagina=${tamanhoPag}&pagina=${pagina}&conteudoLivre=${cne}`;
        return this.http.get(url).toPromise();
    }

    async listarRegiaoAdministrativa(nome: string) {
        const siglaUF = 'DF';
        const codigoUf = '53';
        const urlParams = new URLSearchParams({
            'sigla-uf': siglaUF,
            'codigo-uf': codigoUf,
            nome,
        })
        let url = `${environment.urlBaseNova}/corporativo/municipios/filtro?${urlParams.toString()}`;
        const dados: any = await this.http.get(url).toPromise();
        if(dados.records) {
            return dados.records.sort((d1, d2) => {
                return d1['nome'].localeCompare(d2['nome'])
            });
        }
        return null;
    }



    async listarDistrito(nome: string, filtro?: any, ) {
        const usuario: any = await this.usuarioProvider.getUsuario();
        const splitEsferaAtuacao: Array<string> = usuario.esfera.esferaAtuacao.split('/');
        const codigoUf = splitEsferaAtuacao.length >= 2 ? splitEsferaAtuacao[1] : undefined;
        const codigoMunicipioIbge = splitEsferaAtuacao.length >= 3 && usuario.perfil.sigla !== 'ARS' ? splitEsferaAtuacao[2] : undefined;       
        let url = `${environment.urlBaseNova}/corporativo/distritos?nome=${nome.toUpperCase()}`;

        if (!filtro) {
            filtro = {};
        }
        filtro.codigoUf = codigoUf ? codigoUf : filtro.codigoUf;
        filtro.codigoMunicipioIbge = codigoMunicipioIbge ? codigoMunicipioIbge : filtro.codigoMunicipioIbge;
        if (filtro.codigoMunicipioIbge !== undefined && !filtro.ignoreFiltro) {
            url = url + '&codigo-municipio-ibge=' + filtro.codigoMunicipioIbge;
        }
        if (filtro.codigoDistrito !== undefined && !filtro.ignoreFiltro) {
            url = url + '&codigo-distrito=' + filtro.codigoDistrito;
        }
        if (filtro.codigoUf !== undefined && !filtro.ignoreFiltro) {
            url = url + '&codigo-uf=' + filtro.codigoUf;
        }

        const dados: any = await this.http.get(url).toPromise();
        if(dados.records) {
            return dados.records.sort((d1, d2) => {
                return d1['nome'].localeCompare(d2['nome'])
            })
        }
        return null;
    }

    async getDistritoByCodigo(codigo) {
        const url = environment.urlBaseNova + '/corporativo/distritos/' + codigo;
        return this.http.get(url).toPromise();
    }

    async estabelecimentoByCnes(cnes) {
        const url = `${environment.urlBaseNova}/cnes/estabelecimentos/cnes/${cnes}`;
        const response: any = await this.http.get(url).toPromise();
        return response.record;
    }

    async listarProfissionais(codigo, filtro) {
        let url = `${environment.urlBaseNova}/cnes/rascunhos/${codigo}/profissionais?pagina=0&tamanho-pagina=50&conteudoLivre=${filtro}`;
        return this.http.get(url).pipe(
            map((a: any) => {
                if (a.records && a.records.length > 0) {
                    a.records.forEach((b: Profissional) => {
                        b.nome = b.profissionalSUS.nomeSocial || b.profissionalSUS.nome;
                    });
                }
                return a;
            })
        ).toPromise();
    }

    async listarUnidades(codigo, filtro) {
        let url = `${environment.urlBaseNova}/cnes/rascunhos/${codigo}/enderecos-complementares?pagina=0&tamanho-pagina=50&conteudoLivre=${filtro}&direcao-ordenacao=DESC&ordenacao=NOME_REFERENCIA`;
        return this.http.get(url).toPromise();
    }

    async getRegiaoSaudeByCodigo(codigo) {
        const url = environment.urlBaseNova + '/corporativo/regionais-saude/' + codigo;
        return this.http.get(url).toPromise();
    }

    async listarRegioesSaude(nome: string, filtro?: any) {
        const usuario: any = await this.usuarioProvider.getUsuario();
        const splitEsferaAtuacao: Array<string> = usuario.esfera.esferaAtuacao.split('/');
        const codigoUf = splitEsferaAtuacao.length >= 2 ? splitEsferaAtuacao[1] : undefined;
        const codigoRegionalSaude = splitEsferaAtuacao.length >= 3 && usuario.perfil.sigla === 'ARS' ? splitEsferaAtuacao[2] : undefined;
        let url = `${environment.urlBaseNova}/corporativo/regionais-saude?nome=${nome.toUpperCase()}`;
        if (!filtro) {
            filtro = {};
        }

        filtro.codigoUf = codigoUf ? codigoUf : filtro.codigoUf;
        filtro.codigoRegionalSaude = codigoRegionalSaude ? codigoRegionalSaude : filtro.codigoRegionalSaude;
        if (filtro.codigoRegionalSaude !== undefined && !filtro.ignoreFiltro) {
            url = url + '&codigo-regional-saude=' + filtro.codigoRegionalSaude;
        }
        if (filtro.codigoUf !== undefined && !filtro.ignoreFiltro) {
            url = url + '&codigo-uf=' + filtro.codigoUf;
        }
        return this.http.get(url).toPromise();
    }

    async listarGrupoAtividadePrimaria(codigo = '') {
        const url = `${environment.urlBaseNova}/cnes/grupos-atividade`;
        const retorno = this.http.get(url).toPromise();
        return retorno;
    }

    async listarAtividadePrimaria(codigo) {
        const url = `${environment.urlBaseNova}/cnes/atividades?codigoGrupoAtividade=${codigo}`;
        return this.http.get(url).toPromise();
    }

    async listarGrupoAtividadeSecundaria() {
        const url = `${environment.urlBaseNova}/cnes/grupos-atividade/secundarias`;
        return this.http.get(url).toPromise();
    }

    async listarAtividadeSecundaria(params) {
        const stringParams = this.getUrlParams(params);
        const url = `${environment.urlBaseNova}/cnes/atividades/secundarias?${stringParams}`;
        const retorno = this.http.get(url).toPromise();
        return retorno;
    }

    listarTipoEstabelecimento() {
        const url = `${environment.urlBaseNova}/cnes/tipos-estabelecimento`;
        return this.http.get(url).toPromise();
    }

    validarTipoEstabelecimento(codigoPrincipal, arSecundarias: Array<any>) {
        let url = `${environment.urlBaseNova}/cnes/tipos-estabelecimento/validar?codigo-atividade-principal=${codigoPrincipal}`;

        arSecundarias.forEach(codigo => {
            url += `&codigos-atividades-secundarias=${codigo}`;
        })

        return this.http.get(url).toPromise();
    }

    identificarTipoEstabelecimento(request: any) {
        const url = `${environment.urlBaseNova}/cnes/tipos-estabelecimento/identificar`;
        return this.http.post(url, request).toPromise();
    }

    async listarNivelAtencao(complexidade) {
        const url = `${environment.urlBaseNova}/geral/nivel-atencao?complexidade=` + complexidade;
        return this.http.get(url).toPromise();
    }

    async listarGestaoTipoAtividade() {
        const url = '/cnes/gestoes/tipos-atividade';
        return this.baseService.get(url).toPromise();
    }

    async listarTipoComplexidade(codigo) {
        const url = `${environment.urlBaseNova}/cnes/gestoes/complexidades?codigoTipoAtividade=` + codigo;
        return this.http.get(url).toPromise();
    }

    async listarTipoGestao() {
        // TODO Não tem um domínio para listar tipos de Gestão (Está Fixo no código)
        const url = `${environment.urlBaseNova}/cnes/gestoes/tipos`;
        // return this.http.get('./assets/dados-fake/caracterizacao/gestao.json').toPromise();
        return this.http.get(url).toPromise();
    }

    async listarTipoMarcacao(): Promise<Array<TipoMarcacao>> {
        const url = `/cnes/marcacoes/tipo-marcacao`;
        const response: any = this.baseService.get(url).toPromise();
        return response;
    }

    async listarGrupoMarcacao(): Promise<Array<GrupoMarcacao>> {
        const url = `/cnes/marcacoes/grupo-marcacoes`;
        const response: any = this.baseService.get(url).toPromise();
        return response;
    }

    async listarSubgrupoMarcacao(codigo): Promise<Array<SubGrupoMarcacao>> {
        const url = `/cnes/marcacoes/subgrupo-marcacoes?codigoGrupo=${codigo}`;
        const response: any = this.baseService.get(url).toPromise();
        return response;
    }

    async listarMotivosDesativacao(): Promise<Array<MotivoDesativacao>> {
        const url = `/cnes/motivos-desativacao-estabelecimento`;
        let response: any = await this.baseService.get(url).toPromise();
        if (response) {
            response = response.records;
        }
        return response;
    }

    listarDominioServico() {
        const url = '/cnes/servicos';
        return this.baseService.get(url).toPromise();
    }

    listaFormaContratacaoEstabelecimento() {
        const url = `${environment.urlBaseNova}/cnes/formas-contratacao/estabelecimentos`;
        return this.http.get(url).toPromise();
    }

    listaFormaContratacaoEmpregadores(codigoFormaContratacaoEstabelecimento) {
        const url = `${environment.urlBaseNova}/cnes/formas-contratacao/empregadores?codigo-forma-contratacao-estabelecimento=${codigoFormaContratacaoEstabelecimento}`;
        return this.http.get(url).toPromise();
    }

    listaFormaContratacao(idFormaContratacaoEmpregador) {
        const url = `${environment.urlBaseNova}/cnes/formas-contratacao/detalhamentos?id-forma-contratacao-empregador=${idFormaContratacaoEmpregador}&status-registro-ativo=true`;
        return this.http.get(url).toPromise();
    }

    async listarCNES(filtro, codigo) {
        const url = `${environment.urlBaseNova}/cnes/ine/estabelecimento/${codigo}`;
        return this.http.get(url).toPromise();
    }

    async listarCnesByTipo(codigo, textoLivre) {
        const url = `${environment.urlBaseNova}/cnes/estabelecimentos/tipo-equipe/${codigo}?conteudo-livre=${textoLivre}`;
        return this.http.get(url).toPromise();
    }

    async listarEstabelecimentoParaNotificacao(textoLivre) {
        if(!textoLivre || textoLivre.length < 3) {
            return;
        }
        const url = `${environment.urlBaseNova}/cnes/estabelecimentos/listagem?conteudo-livre=${textoLivre}`;
        return this.http.get(url).toPromise();
    }

}
